export const unescapeHtmlEntities = (str: string) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(str, 'text/html');
	return doc.documentElement.textContent ?? '';
};

export const handleAuth0CustomErrorMessage = (errorCode: string) => {
	switch (errorCode) {
		case 'not-verified':
			return "Please verify your email address before logging in to your account.";
		case 'no-consumer':
			return "Your user ID is currently not associated with a Language IO account. Please reach out to your internal LIO administrator for support. If you are the LIO administrator for your organization, please submit a support ticket"
		case 'disabled':
			return "Your account has been suspended. Please reach out to the Language IO support team for additional details.";
		case 'mfa-check-failed':
		case 'none':
			return "Failed to login. Please try again later or contact technical support";
		case 'internal-server-error':
			return "An unexpected error occurred during login, please try again later or contact technical support";
		default:
			return null;
	}
}